import React from 'react';
import { showSnackBar } from 'consts';
import Button, { ButtonProps } from 'tradevan-ui/Button';
import ButtonVariantEnum from 'tradevan-ui/Button/enum';

interface LinkDivProps extends ButtonProps {
  onClick?: React.MouseEventHandler<HTMLElement>;

  text: string;
}
const CopyButton = (props: LinkDivProps): JSX.Element => {
  const {
    onClick,
    text,
    variant = ButtonVariantEnum.link,

    ...other
  } = props;
  // 將文字寫到剪貼簿
  const writeClipboard = () => {
    navigator.clipboard.writeText(text as string);
    showSnackBar(`已複製至剪貼簿`, 'success');
  };
  return (
    <div
      style={{
        display: text ? 'flex' : 'none',
        justifyContent: 'center',
      }}
    >
      <Button
        style={{ padding: 0, fontSize: 14 }}
        variant={variant}
        onClick={onClick}
        {...other}
      >
        {text}
      </Button>
      <Button
        title="複製"
        onClick={(e) => {
          e.stopPropagation();
          writeClipboard();
        }}
        style={{ padding: '0 0 0 4px' }}
        variant={ButtonVariantEnum.link}
        startIcon={<i className="icon-app_copy" />}
      />
    </div>
  );
};
export default CopyButton;
